var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutline = function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 62,
    fill: "#847128",
    viewBox: "0 0 32 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 10.37 15.479.34a.57.57 0 0 1 1.044 0l4.437 10.03 10.529 1.114a.575.575 0 0 1 .329.992l-7.763 7.241 2.219 10.59a.572.572 0 0 1-.849.612L16 25.35l-9.424 5.57a.572.572 0 0 1-.849-.613l2.219-10.589-7.763-7.241a.575.575 0 0 1 .33-.992l10.528-1.113zM16 1.988l-4.05 9.153a.57.57 0 0 1-.461.338l-9.607 1.016 7.079 6.603a.58.58 0 0 1 .17.539L7.11 29.27l8.6-5.08a.57.57 0 0 1 .579 0l8.598 5.08-2.019-9.634a.58.58 0 0 1 .17-.54l7.079-6.602-9.607-1.016a.57.57 0 0 1-.462-.338z"
  })));
};
export default SvgStarOutline;